.container {
  display: flex;
  flex-direction: column;
  width: 4rem;
  min-width: 4rem;
  position: relative;
  transition: all 0.2s ease;
  border-right: 1px var(--content-border-color) solid;

  &[data-expand='true'] {
    width: 20rem;
    min-width: 20rem;
  }
}

.menu-content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

.subtitle {
  margin-top: 0.8rem;
  font-size: 1.3rem;
  height: 2.6rem;
  color: transparent;
  display: flex;
  align-items: center;
  padding: 0.4rem;

  &:after {
    content: '';
    position: absolute;
    transform: translateX(-0.8rem);
    height: 1px;
    width: 100%;
    background: var(--color-surfaces-bg-elevation-2);
  }

  &[data-expand='true'] {
    color: #7a8296;

    &:after {
      display: none;
    }
  }
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0.4rem;
}

.menu-toggle-button {
  all: unset;
  width: 3.2rem;
  height: 3.2rem;
  border-radius: var(--border-radius-small);
  background: var(--color-surfaces-app-background-0);
  color: var(--color-texts-low-contrast);
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    color: var(--color-texts-high-contrast);
    background: var(--bg-elevation-2);
  }
}
